import { Component, Input, OnInit } from '@angular/core';
import { trackByRoute } from '../../utils/track-by';
import { NavigationService } from '../../services/navigation.service';
import icRadioButtonChecked from '@iconify/icons-ic/twotone-radio-button-checked';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vex-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input() collapsed: boolean = false;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
  imageUrl$ = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  showCollapsePin$ = this.configService.config$.pipe(map(config => config.sidenav.showCollapsePin));
  logoCollapse = 'assets/img/demo/small_saranyu_logo.svg'
  items = this.navigationService.items;
  trackByRoute = trackByRoute;
  icRadioButtonChecked = icRadioButtonChecked;
  icRadioButtonUnchecked = icRadioButtonUnchecked;
  showlogo:boolean = false;

  constructor(private navigationService: NavigationService,
              private layoutService: LayoutService,
              private configService: ConfigService) { }

  ngOnInit() {
    //to close the sidenav on load
    // this.layoutService.collapseSidenav()
  }

  ngAfterContentChecked(){
    this.items = this.navigationService.items;
  }

  onMouseEnter() {
    this.layoutService.collapseOpenSidenav();
    this.showlogo = false;
    if(this.collapsed === false){
      this.showlogo = false
    }
  }

  onMouseLeave() {
    this.layoutService.collapseCloseSidenav();
    this.showlogo = true;
    if(this.collapsed === false){
      this.showlogo = false
    }
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
    if(this.collapsed === false){
      this.showlogo = false;
    }
  }
}
